import { takeEvery, takeLatest } from 'redux-saga/effects';
import { VISITS_MODULE } from '../../../configs/moduleNames';
import { EXPORT_VISIT, LOAD_VISIT_BY_ID, LOAD_VISIT_LIST } from '../actions';
import loadVisitList from './loadVisitList';
import loadVisitById from './loadVisitById';
import exportVisit from './exportVisit';

export default function* watchClient() {
  yield takeLatest(VISITS_MODULE + LOAD_VISIT_LIST, loadVisitList);
  yield takeEvery(VISITS_MODULE + LOAD_VISIT_BY_ID, loadVisitById);
  yield takeEvery(VISITS_MODULE + EXPORT_VISIT, exportVisit);
}
